import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { expedienteElectronicoService } from './expedienteElectronico.service';
import { NotificacionesICOIJDto } from './interfaces/NotificacionesICOIJDto.interface';
import { Observable, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../commons/services/auth.service';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../../commons/components/alert/alert.component';
import { AlertService } from '../../commons/components/alert/alert.service';
import * as bootstrap from 'bootstrap';
import { LibInterconexionEEModule, RequestEeInterface } from 'interconexion.ee-lib';
import { ExportarExcel } from "../../commons/shared/Excel/exportar-excel/exportar-excel";
import { DocumentJsonService } from '../../commons/services/document-json-service';
import { ENV_TOKEN } from '../../app-module.token';

@Component({
  selector: 'oaj-expediente-electronico-itx',
  templateUrl: 'expedienteElectronico.component.html',
  styleUrls: ['expedienteElectronico.component.css'],
  imports: [CommonModule, NgbPagination, FormsModule, AlertComponent, LibInterconexionEEModule, ExportarExcel]
})
export class ExpedienteElectronicoComponent implements OnInit {
  private service: expedienteElectronicoService = inject(expedienteElectronicoService);
  private _documentJsonService: DocumentJsonService = inject(DocumentJsonService);
  private authServ: AuthService = inject(AuthService);
  private alertService: AlertService = inject(AlertService);
  readonly environment = inject(ENV_TOKEN);
  constructor() {
    // TODO: inject a service to fetch/save expedientes, e.g. ExpedienteService
    this.baseUrl = `${this.environment.RutaVistaEE}`;
    this.getModuloEEVisible();
  }
  loading = false;
  loadingInicio = false;
  datos: Observable<NotificacionesICOIJDto[]> = of([]);

  _Record: RequestEeInterface | undefined;
  public isCompletedEE = false;
  private baseUrl = "";
  private openEE = false;

  page = 1;
  pageSize = 10;
  collectionSize = 0;
  pageSizes: number[] = [5, 10, 15];
  filter = '';
  columnasReporte = [
    { header: 'Neun', key: 'neun', width: 20 },
    { header: 'Expediente', key: 'expediente', width: 20 },
    { header: 'Tipo de Asunto', key: 'tipoAsunto', width: 30 },
    { header: 'Órgano Jurisdiccional PJF', key: 'organoJuridisccional', width: 100 },
    { header: 'Circuito', key: 'circuito', width: 25 },
  ];

  @ViewChild(ExportarExcel) exportarExcelComp!: ExportarExcel;
  nombreAutoridad!: string;


  ngOnInit(): void {
    this.nombreAutoridad = '(' + this.authServ.getIdOrgan() + ') ' + this.authServ.getNameCourt();
    this.busquedaInicial('');
  }

  /**
   * Funcion para actualizar la lista de notificaciones, se llama despues de realizar alguna accion que pueda modificar la informacion mostrada en pantalla como crear, editar o eliminar una configuracion de dia inhábil, se hace una consulta al servicio para obtener las notificaciones dependiendo del organo del usuario autenticado, se muestra un mensaje de error si ocurre un error durante la consulta de las notificaciones
   * @returns
   */
  actualizaLista() {
    this.busquedaInicial('');

  }

  /**
   * Funcion para realizar la busqueda inicial de notificaciones, se hace una consulta al servicio para obtener las notificaciones dependiendo del organo del usuario autenticado, se muestra un mensaje de error si ocurre un error durante la consulta de las notificaciones
   * @param event 
   */
  busquedaInicial(event: any) {
    this.loadingInicio = true;
    this.service.buscarNotificaciones(this.page, this.pageSize, this.authServ.getIdOrgan(), event)
      .subscribe({
        next: (x) => {
          if (x.succcess) {
            this.datos = of(x.data);
            this.collectionSize = x.totalCount;

          }
          // console.log('notificaciones', x);
          this.loadingInicio = false;
        },
        error: () => {
          this.loadingInicio = false;
        }
      });
  }

  /**
   * Funcion para realizar la busqueda de notificaciones, se hace una consulta al servicio para obtener las notificaciones dependiendo del organo del usuario autenticado, se muestra un mensaje de error si ocurre un error durante la consulta de las notificaciones
   * @param event 
   */

  buscar(event: any) {
    // console.log(event);
    this.loading = true;
    this.service.buscarNotificaciones(this.page, this.pageSize, this.authServ.getIdOrgan(), event)
      .subscribe({
        next: (x) => {
          if (x.succcess) {
            this.datos = of(x.data);
            this.collectionSize = x.totalCount;

          }
          // console.log('notificaciones', x);
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  /**
   * Funcion para abrir el expediente electronico o el ebook dependiendo de la configuracion de visibilidad del expediente electronico, si la propiedad openEE es verdadera se muestra la captura del expediente electronico, si es falsa se abre el ebook, se muestra un mensaje de error si ocurre un error durante la consulta de la configuracion de visibilidad del expediente electronico
   * @param item 
   * @param modal 
   */
  fnAperturaEE_Ebook(item: NotificacionesICOIJDto, modal: any) {
    if (this.openEE) {
      this.fnVerCapturaExpedienteElectronico(item, modal);
    }
    else {
      this.fnOpenEbook(item);
    }
  }

  /**
   * Funcion para mostrar la captura del expediente electronico, se muestra una modal con la captura del expediente electronico dependiendo del neun seleccionado, se muestra un mensaje de error si ocurre un error durante la consulta del expediente electronico
   * @param item 
   * @param modal 
   */
  fnVerCapturaExpedienteElectronico(item: NotificacionesICOIJDto, modal: any): void {
    item.loading = true;
    this.isCompletedEE = false;
    this._Record = { asuntoNeunId: item.neun, parteItxId: item.personID };
    setTimeout(() => this.isCompletedEE = true);
    const modalElement = document.getElementById(modal);

    if (modalElement) {
      const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
      modal.show();
    }
    item.loading = false;
  }

  /**
   *  Funcion para abrir el ebook, se hace una consulta al servicio para obtener el token de acceso al ebook, si se obtiene el token se construye la url del ebook con los parametros necesarios y se abre en una nueva ventana, se muestra un mensaje de error si no se pudo generar el token o si ocurre un error durante la consulta del token
   * @param item 
   */
  fnOpenEbook(item: NotificacionesICOIJDto): void {
    item.loading = true;
    //this.errorMessage = '';
    const idParteItx = item.personID ?? 13; // Valor predeterminado si no se proporciona
    this.service.getToken().subscribe({
      next: (ResponseTokenInterface) => {
        const stringToken = ResponseTokenInterface?.data?.token;
        if (stringToken == null || stringToken === '') {
          item.loading = false;
          this.alertService.error(`No se pudo generar el token, intente nuevamente`, { autoClose: true, keepAfterRouteChange: false });
          return;
        }
        /*const urlExpElectronic = `${this.baseUrl}param1=${item.neun}&param2=13&param3=${idParteItx}&param4=${stringToken}`;*/
        /*const params = new URLSearchParams({
          param1: item.neun.toString(),
          param2: '13',
          param3: idParteItx.toString(),
          param4: stringToken
        });
        const urlExpElectronic = `${this.baseUrl}${params.toString()}`;*/
        const urlExpElectronic = `${this.baseUrl}param1=${encodeURIComponent(item.neun)}&param2=13&param3=${encodeURIComponent(idParteItx)}&param4=${encodeURIComponent(stringToken)}`;
        window.open(urlExpElectronic, '_blank');
        item.loading = false;
      },
      error: (error: any) => {
        item.loading = false;
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
      },
    });
  }

  /**
   * Funcion para exportar la lista de notificaciones a un archivo excel, se hace una consulta al servicio para obtener todas las notificaciones dependiendo del organo del usuario autenticado, si se obtiene la informacion se asigna a la propiedad data del componente de exportar excel y se llama a la funcion export para generar el archivo excel, se muestra un mensaje de error si ocurre un error durante la consulta de las notificaciones o si no se obtiene informacion para exportar
    * @returns
     *
   */
  busquedaCompletaExportar() {
    this.loading = true;
    this.service.buscarNotificaciones(1, this.collectionSize, this.authServ.getIdOrgan())
      .subscribe({
        next: (x) => {
          if (x.succcess) {
            this.exportarExcelComp.data = x.data;
            this.exportarExcelComp.export();
          }
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  /**
   * Funcion para obtener la configuracion de visibilidad del expediente electronico, se hace una consulta al servicio para obtener la configuracion dependiendo del organo del usuario autenticado, si se obtiene la configuracion se asigna el valor a la propiedad openEE para determinar si se muestra o no el expediente electronico, se muestra un mensaje de error si ocurre un error durante la consulta de la configuracion
   * @returns
   */
  getModuloEEVisible() {
    this._documentJsonService.getModuloEEVisible().then((response) => {
      if (response === null) {
        return;
      }
      if (response?.isEEVisibleAll != null && response.isEEVisibleAll) {
        this.openEE = true;
        return;
      }
      if (response?.isEEVisibleOrgano != null && response.isEEVisibleOrgano && response.lstOrganoPermiso != null) {
        const existePermiso = response.lstOrganoPermiso.filter((p: { idOrgano: any; }) => p.idOrgano === this.authServ.getIdOrgan());
        if (existePermiso && existePermiso.length > 0) {
          this.openEE = true;
        }
        return;
      }
    });
  }

}